// ============================================
// Resume Modal
//
// Shown when a returning patient has an active journey.
// Offers "Continue where you left off" or "Start fresh."
// ============================================

interface ResumeModalProps {
  onResume: () => void;
  onStartFresh: () => void;
}

export function ResumeModal({ onResume, onStartFresh }: ResumeModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-6">
      <div className="bg-bg-card border border-bg-tertiary rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <h2 className="font-display text-xl font-bold text-text-primary">
          Welcome back
        </h2>
        <p className="mt-3 text-text-secondary text-base leading-relaxed">
          It looks like you were in the middle of something. Want to pick up where you left off?
        </p>

        <div className="mt-8 flex flex-col gap-3">
          <button
            onClick={onResume}
            className="w-full py-4 rounded-xl bg-accent text-white text-base font-bold
              hover:bg-accent-light transition-colors"
          >
            Continue where I left off
          </button>
          <button
            onClick={onStartFresh}
            className="w-full py-3 rounded-xl border-2 border-bg-tertiary text-text-secondary text-base
              font-medium hover:border-text-muted transition-colors"
          >
            Start fresh
          </button>
        </div>
      </div>
    </div>
  );
}
